import * as React from "react"
import MarkDelayModal from "../components/MarkDelayModal";
import MarkDelaySuccessModal from "../components/MarkDelaySuccessModal";
import AppUtils from "../utils/AppUtils";

interface IMarkDelayContainer {
    startTimeEpoch: number,
    bookingId: number,
    appointmentId: number,
    patientName: string,
    fetchAppointments: () => void,
    appointmentStatus: string
}

const MarkDelayContainer = (props: IMarkDelayContainer) => {
    if (!AppUtils.shouldRenderMarkDelay(props.appointmentStatus)) return null

    const [showModal, setShowModal] = React.useState<boolean>(false)
    const [showSuccessModal, setShowSuccessModal] = React.useState<boolean>(false)
    const [delayParams, setDelayParams] = React.useState<{delayedInMinutes: number, epoch: number}>(null)

    const handleClearClick = (ev: any) => {
        setShowModal(true)
    }

    const handleSaveSuccess = (delayedInMinutes: number, epoch: number) => {
        setShowModal(false)
        setShowSuccessModal(true)
        setDelayParams({delayedInMinutes, epoch})
    }

    const handleSuccessModalClick = () => {
        setShowSuccessModal(false)
        props.fetchAppointments && props.fetchAppointments()
    }

    return (
        <div onClick={e => e.stopPropagation()}>
            <img src="/images/icons/mark_delay.svg" />
            <span onClick={handleClearClick} style={{cursor: "pointer", color: "#e4306e", fontFamily: "BrandonTextWeb-Medium", fontSize: 14}}>Mark Delay</span>
            {showModal && <MarkDelayModal startTimeEpoch={props.startTimeEpoch} bookingId={props.bookingId} appointmentId={props.appointmentId} patientName={props.patientName} closeModal={() => setShowModal(false)} handleSaveSuccess={handleSaveSuccess}/>}
            {showSuccessModal && <MarkDelaySuccessModal closeModal={handleSuccessModalClick} patientName={props.patientName} delayedInMinutes={delayParams && delayParams.delayedInMinutes} oldTimeEpoch={props.startTimeEpoch} newTimeEpoch={delayParams && delayParams.epoch}/>}
        </div>
    )
}

export default MarkDelayContainer